module.exports = __webpack_public_path__ + "img/safe_house_icon2.282225b6.svg";